import { defineMessages } from 'react-intl';

export default defineMessages({
  LoadingUsersSurveysError: {
    defaultMessage: 'Survey couldn’t be loaded. Please try again later.',
    id: 'LoadingUsersSurveysError',
  },
  SharedNotificationCopyingNotAllowed: {
    defaultMessage: "Your browser doesn't allow copying to the clipboard",
    id: 'shared.notification.copyingNotAllowed',
  },
  SurveyAnswerError: {
    defaultMessage: 'Survey Answer Error',
    id: 'SurveyAnswerError',
  },
  SurveySuccessfullyAnswered: {
    defaultMessage: 'Survey successfully answered',
    id: 'SurveySuccessfullyAnswered',
  },
});
